/*
Add GTM Datalayer click event on ALL product cards available in ALL pages
*/

const addDataLayers_ProductClickEvent = () => {
    const productCards = document.querySelectorAll(".product-item:not(.gtm-product-click-event), .quick-search-product-item:not(.gtm-product-click-event)");
    if(productCards){
        productCards.forEach((productCard) => {
            // Add class in order to avoid adding click event several times on same product especially in catalog (due to progressive display on scroll).
            // If this class is already there, the product card is ignored.
            // This will prevent the product card from having the same click event several times and, therefore, adding the same data layer several times.
            productCard.classList.add('gtm-product-click-event');

            const links = productCard.querySelectorAll('.product-item__image-link, h4 a, .show-product-quickview, .quick-search__result');
            if(links){
                links.forEach((link) => {
                    link.addEventListener('click', () => {
                        link.dataset.productName     = productCard.dataset.productName;
                        link.dataset.productId       = productCard.dataset.productId;
                        link.dataset.productPrice    = productCard.dataset.productPrice;
                        link.dataset.productBrand    = productCard.dataset.productBrand;
                        link.dataset.productCategory = productCard.dataset.productCategory;
                        link.dataset.productVariant  = productCard.dataset.productVariant;
                        link.dataset.productPosition = productCard.dataset.productPosition;
                        link.dataset.productList     = productCard.dataset.productList;
                        gtm_datalayer('product_click', link);
                    });
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
  addDataLayers_ProductClickEvent();
})